import React from 'react';
import ReactDOM from 'react-dom';
import NaturalLanguageForm from '../jsx/NaturalLanguageForm';

export default function _naturalLanguageSearchForm() {
    /**
     * Component item selector
     * @const {string}
     */
    const SELECT_INPUT_SELECTOR = '.js-nlf-search-component';

    class NaturalLanguageSearchForm {
        constructor() {
            const reactAppWrapper = document.querySelector('#react-nlf-root');
            const reactAppSearchUrl =
                reactAppWrapper.getAttribute('data-search-url');

            const reactAppLookupUrl =
                reactAppWrapper.getAttribute('data-lookup-url');

            const reactElement = React.createElement(
                NaturalLanguageForm,
                { searchUrl: reactAppSearchUrl, lookupUrl: reactAppLookupUrl },
                null
            );

            // Add the REACT component to the page
            if (reactAppWrapper !== null) {
                ReactDOM.render(reactElement, reactAppWrapper);
            }

            // Any other JavaScript can go here as per standard.
        }
    }

    const components = document.querySelectorAll(SELECT_INPUT_SELECTOR);
    components.forEach((component) => {
        const DOMItem = component;

        // Attach the instance to the DOM once
        if (!DOMItem.component) {
            DOMItem.component = new NaturalLanguageSearchForm();
        }
    });
}

_naturalLanguageSearchForm();
